export enum FaceCheckPage {
  Media = 'media',
  MediaError = 'mediaError',
  OrientationError = 'orientationError',
  Check = 'check',
  Upload = 'upload',
}
